module.exports = __webpack_public_path__ + "img/googlePlayBg.3e2e9769.png";